import { type RelatedArticles } from "@/types"
import { sortArticlesByNewest } from "../Grid/helpers"

function getDate(article: RelatedArticles) {
    return new Date(article.articleCreationDate ?? article._createdAt).getTime()
}

function sortFunction(a: RelatedArticles, b: RelatedArticles) {
    return getDate(b) - getDate(a)
}

export const filterArticles = (
    articles: RelatedArticles[] | undefined,
    selectedFilterOption: string,
    selectedSortOption: string
) => {
    // Default sorting: newest to oldest
    const sortedArticles = sortArticlesByNewest(articles)
    const filteredArticles = sortedArticles
        ?.filter(article => {
            if (selectedFilterOption === "all") {
                return true
            }
            return article.articleCategories?.some(
                category => category.categoryTitle.toLowerCase() === selectedFilterOption
            )
        })
        .sort((a, b) => {
            if (selectedSortOption === "newest") {
                return sortFunction(a, b)
            } else if (selectedSortOption === "oldest") {
                return sortFunction(b, a)
            } else {
                return a.pageHeading.localeCompare(b.pageHeading)
            }
        })
    return filteredArticles
}

export const sortArticles = (
    articles: RelatedArticles[] | undefined,
    selectedSortOption: string
) => {
    // Default sorting: newest to oldest
    const sortedArticles = articles?.slice().sort((a, b) => {
        if (selectedSortOption === "newest" || !selectedSortOption) {
            return sortFunction(a, b)
        } else if (selectedSortOption === "oldest") {
            return sortFunction(b, a)
        } else {
            return a.pageHeading.localeCompare(b.pageHeading)
        }
    })
    return sortedArticles
}
